import { Box, Grid, InputLabel, OutlinedInput, Paper, Tab, Tabs } from "@mui/material";
import moment from "moment";
import React from "react";
import DefaultPreviewPdfFile from "../../components/default-preview-pdf-file";
import { usePublicacaoDiarioOficialState } from "./context/publicacao-diario-oficial-context";
import { usePublicacaoDiarioOficialController } from "./context/publicacao-diario-oficial-controller";


export const PublicacaoDiarioOficialPreview = () => {
    const { previewPublicationResponse, tabIndePreview } = usePublicacaoDiarioOficialState();
    const { handleTabPreviewChange } = usePublicacaoDiarioOficialController();

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid item xs={6} md={6} lg={6}>
                    <Paper
                        sx={{
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column'
                        }} elevation={3}
                    >
                        <Box>
                            <Box>
                                <Tabs value={tabIndePreview} onChange={handleTabPreviewChange}>
                                    <Tab label="Diário Oficial" />
                                    <Tab label="Publicação" />
                                    <Tab label="Contas Públicas" />
                                </Tabs>
                            </Box>
                        </Box>
                        <Box sx={{ pt: 2 }}>
                            {tabIndePreview === 0 && (
                                <Box>
                                    <DefaultPreviewPdfFile fileUrl={previewPublicationResponse?.files?.officialDaily.fileUrl}></DefaultPreviewPdfFile>
                                </Box>
                            )}
                            {tabIndePreview === 1 && (
                                <Box>
                                    <DefaultPreviewPdfFile fileUrl={previewPublicationResponse?.files?.publication.fileUrl}></DefaultPreviewPdfFile>
                                </Box>
                            )}
                            {tabIndePreview === 2 && (
                                <Box>
                                    <DefaultPreviewPdfFile fileUrl={previewPublicationResponse?.files?.publicAccount.fileUrl}></DefaultPreviewPdfFile>
                                </Box>
                            )}
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                    <Paper
                        sx={{
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column'
                        }} elevation={3}
                    >
                        <Grid container spacing={2}>
                            <Grid
                                item
                                lg={2}
                                sm={2}
                                xl={2}
                            >
                                <InputLabel>Ano</InputLabel>
                                <OutlinedInput
                                    disabled
                                    size="small"
                                    value={previewPublicationResponse?.yearPublication}
                                    fullWidth
                                />
                            </Grid>
                            <Grid
                                item
                                lg={2}
                                sm={2}
                                xl={2}
                            >
                                <InputLabel>Nº Edição</InputLabel>
                                <OutlinedInput
                                    disabled
                                    size="small"
                                    value={previewPublicationResponse?.editionNumber}
                                    fullWidth
                                />
                            </Grid>


                            <Grid
                                item
                                lg={3}
                                sm={3}
                                xl={3}
                            >
                                <InputLabel>Data da Publicação</InputLabel>
                                <OutlinedInput
                                    disabled
                                    size="small"
                                    value={moment(previewPublicationResponse?.publicationDateOn).format("DD/MM/yyyy")}
                                    fullWidth
                                />
                            </Grid>
                            <Grid
                                item
                                lg={12}
                                sm={12}
                                xl={12}
                            >
                                <InputLabel>Entidade</InputLabel>
                                <OutlinedInput
                                    disabled
                                    value={previewPublicationResponse?.client}
                                    fullWidth
                                />
                            </Grid>
                            <Grid
                                item
                                lg={12}
                                sm={12}
                                xl={12}
                            >
                                <InputLabel>Categoria</InputLabel>
                                <OutlinedInput
                                    disabled
                                    size="small"
                                    value={previewPublicationResponse?.category}
                                    fullWidth
                                />
                            </Grid>

                            <Grid
                                item
                                lg={12}
                                sm={12}
                                xl={12}
                            >
                                <InputLabel>Subategoria</InputLabel>
                                <OutlinedInput
                                    disabled
                                    size="small"
                                    value={previewPublicationResponse?.subcategory}
                                    fullWidth
                                />
                            </Grid>

                            <Grid
                                item
                                lg={12}
                                sm={12}
                                xl={12}
                            >
                                <InputLabel>Orgão de Publicação</InputLabel>
                                <OutlinedInput
                                    disabled
                                    size="small"
                                    value={previewPublicationResponse?.publicAgency}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={12} lg={12}>
                                <InputLabel>Descrição</InputLabel>
                                <OutlinedInput
                                    disabled
                                    size="small"
                                    multiline
                                    rows={15}
                                    value={previewPublicationResponse?.description}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </React.Fragment>)
}